import { PinFieldDisplay } from 'components/Field/PinFieldDisplay';
import { useSelector } from 'hooks/useSelector';
import { pureComponent } from 'lib/pureComponent';
import React from 'react';
import { useDispatch } from 'react-redux';
import { doAssetLoadPlans } from 'store/actions';
import { selectAssetPlan } from 'store/assets/selectors';
import { PinNew } from 'store/plan/types';

interface Props {
  assetId: string;
  pin: PinNew | undefined;
}

export const PinDisplayRowAsset: React.FC<Props> = pureComponent(
  ({ assetId, pin }) => {
    const dispatch = useDispatch();

    const plan =
      useSelector((state) =>
        selectAssetPlan(state, assetId, pin ? pin.planId : '-1'),
      ) || undefined;

    return (
      <PinFieldDisplay
        pin={plan ? pin : undefined}
        plan={plan}
        onPress={
          plan && pin
            ? () =>
                dispatch(
                  doAssetLoadPlans({
                    assetId,
                    pin,
                    pins: [],
                  }),
                )
            : undefined
        }
      />
    );
  },
);
